import { render } from "./InputBar.vue?vue&type=template&id=5360e477&scoped=true"
import script from "./InputBar.vue?vue&type=script&lang=js"
export * from "./InputBar.vue?vue&type=script&lang=js"

import "./InputBar.vue?vue&type=style&index=0&id=5360e477&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5360e477"

export default script